import { GetAllGeolocationsInDto } from '../../../types/geolocation.dto'

export const GET_ALL_GEOLOCATIONS_STATICS = 'GET_ALL_GEOLOCATIONS_STATICS'
export const GET_ALL_GEOLOCATIONS_STATICS_SUCCESS = 'GET_ALL_GEOLOCATIONS_STATICS_SUCCESS'
export const GET_ALL_GEOLOCATIONS_STATICS_ERROR = 'GET_ALL_GEOLOCATIONS_STATICS_ERROR'
export const RESET_GET_ALL_GEOLOCATIONS_STATICS = 'RESET_GET_ALL_GEOLOCATIONS_STATICS'

export interface GetAllGeolocationsStatics {
  type: typeof GET_ALL_GEOLOCATIONS_STATICS
  payload: null
}

export interface GetAllGeolocationsStaticsSuccess {
  type: typeof GET_ALL_GEOLOCATIONS_STATICS_SUCCESS
  payload: GetAllGeolocationsInDto
}

export interface GetAllGeolocationsStaticsError {
  type: typeof GET_ALL_GEOLOCATIONS_STATICS_ERROR
  payload: string | boolean
}

export interface ResetGetAllGeolocationsStatics {
  type: typeof RESET_GET_ALL_GEOLOCATIONS_STATICS
  payload: null
}

export interface State {
  data: GetAllGeolocationsInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions =
  | GetAllGeolocationsStatics
  | GetAllGeolocationsStaticsSuccess
  | GetAllGeolocationsStaticsError
  | ResetGetAllGeolocationsStatics
